import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Self-hosted so `font-src 'self'` holds. A CDN font would need the policy
// widened for a request that adds nothing but a third party to trust.
import "@fontsource-variable/archivo";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";

import "./globals.css";
import { App } from "./App";

const container = document.getElementById("root");
if (!container) {
  throw new Error("index.html is missing #root; the shell served something unexpected.");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
